import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedNumber } from 'react-intl';

import { CustomFormInput, FormField } from '../../../../utils/FormFields';
import EarningAccounts from './Accounts';

const EarningRecovery = ({ earning }) => (
  <React.Fragment>
    <Row>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Sending Custodian">
          {earning.EarningRecoverySendingCustodianName}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Receiving Custodian">
          {earning.EarningRecoveryReceivingCustodianName}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Currency">
          {earning.EarningRecoveryCurrencyISO}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Status">
          {earning.EarningRecoveryStatus}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Settlement Date">
          <FormattedDate value={`${earning.EarningRecoverySettlementDate}T00:00`} />
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Description">
          {earning.EarningRecoveryDescription}
        </CustomFormInput>
      </Col>
    </Row>
    <hr />
    <EarningAccounts accounts={earning.EarningAccount} />
  </React.Fragment>
);

EarningRecovery.propTypes = {
  earning: PropTypes.object.isRequired,
};

export default EarningRecovery;
